import axios from "axios";
import { UserModel } from "../../lib/Domain/User/User";
import firebase from "../../firebase.client";
import * as u from "../../utils";

class UserClient {
  public async findUserById(userId: string): Promise<UserModel> {
    if (!userId) return Promise.reject("Invalid User Id");

    const { data } = (await axios.post("/api/user/get-by-id", { id: [userId] }))
      .data;

    if (Array.isArray(data) && data.length === 1) {
      return data[0];
    }
  }

  public async updateUser(user: Partial<UserModel>): Promise<boolean> {
    const response = await axios.post("/api/user/update-user", {
      updates: user,
    });

    if (!response.data.success)
      throw new Error("Unable to update user successfully");

    return response.data.data;
  }

  public async updateUserImage(fileUrl: string): Promise<string> {
    if (fileUrl) {
      const imageName = u.uuid();
      const fireStorageRef = firebase.storage().ref();
      const currentFileRef = fireStorageRef.child(imageName);

      const response = await fetch(fileUrl);
      const fileBlob = await response.blob();

      await currentFileRef.put(fileBlob);
      const imageUrl = await currentFileRef.getDownloadURL();
      return `${imageUrl.split("?")[0]}_800x800?${imageUrl.split("?")[1]}`;
    }
  }

  public async paginateUserIds(
    userIds: string[],
    token: string | undefined | null
  ) {
    if (token === null) return { nextToken: null, data: [], remaining: [] };

    let ids = [...userIds];
    const limit = 30;
    const start =
      token && userIds.includes(token)
        ? userIds.findIndex((el) => el === token)
        : 0;
    const end = start + limit;

    if (ids.length > 30) {
      ids = ids.slice(start, end);
    }

    const { data } = (await axios.post("/api/user/get-by-id", { id: ids }))
      .data;

    return {
      nextToken: userIds[end] || null,
      data,
      remaining: userIds.slice(end) || [],
    };
  }
}

export default UserClient;
